// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__lQdUL","productName":"Table_productName__3UTWB"};